import React, {Component, Fragment} from "react";
import axios from "axios";
import RatingListItem from "../../components/RatingListItem/RatingListItem";

class RatingList extends Component {

    constructor(props) {
        super(props);
        document.title = 'Rating list';
    }

    state = {
        hotelName:"",
        ratings: []
    };

    componentDidMount() {
        axios.get("/api/ratings/" + this.props.match.params.id)
            .then(response => {
                console.log('ratings: ', response.data);
                this.setState({
                    ratings: response.data.ratingListDetails,
                    hotelName: response.data.hotelName
                })
            })
    }

    render() {


        return (
            <Fragment>
                <div className="container">
                    <h2 className="card-title">Ratings</h2>
                    <h3 className="card-title">{this.state.hotelName}</h3>
                    <div className="row">

                        {this.state.ratings.map((rating) =>
                            <RatingListItem
                                key={rating.id}
                                id={rating.id}
                                userName={rating.userName}
                                rating={rating.rating}
                                ratingText={rating.ratingText}

                            />
                        )}
                    </div>
                </div>

            </Fragment>
        )
    }
}

export default RatingList;


// WEBPACK FOOTER //
// ./src/containers/RatingList/RatingList.jsx